import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition } from './../../wayfinder'
/**
* @see \App\Http\Controllers\AuthController::logout
 * @see app/Http/Controllers/AuthController.php:323
 * @route '/logout'
 */
export const logout = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: logout.url(options),
    method: 'post',
})

logout.definition = {
    methods: ["post"],
    url: '/logout',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\AuthController::logout
 * @see app/Http/Controllers/AuthController.php:323
 * @route '/logout'
 */
logout.url = (options?: RouteQueryOptions) => {
    return logout.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\AuthController::logout
 * @see app/Http/Controllers/AuthController.php:323
 * @route '/logout'
 */
logout.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: logout.url(options),
    method: 'post',
})

    /**
* @see \App\Http\Controllers\AuthController::logout
 * @see app/Http/Controllers/AuthController.php:323
 * @route '/logout'
 */
    const logoutForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
        action: logout.url(options),
        method: 'post',
    })

            /**
* @see \App\Http\Controllers\AuthController::logout
 * @see app/Http/Controllers/AuthController.php:323
 * @route '/logout'
 */
        logoutForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
            action: logout.url(options),
            method: 'post',
        })
    
    logout.form = logoutForm
/**
* @see \App\Http\Controllers\AuthController::forgetDevice
 * @see app/Http/Controllers/AuthController.php:357
 * @route '/forget-device'
 */
export const forgetDevice = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: forgetDevice.url(options),
    method: 'post',
})

forgetDevice.definition = {
    methods: ["post"],
    url: '/forget-device',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\AuthController::forgetDevice
 * @see app/Http/Controllers/AuthController.php:357
 * @route '/forget-device'
 */
forgetDevice.url = (options?: RouteQueryOptions) => {
    return forgetDevice.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\AuthController::forgetDevice
 * @see app/Http/Controllers/AuthController.php:357
 * @route '/forget-device'
 */
forgetDevice.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: forgetDevice.url(options),
    method: 'post',
})

    /**
* @see \App\Http\Controllers\AuthController::forgetDevice
 * @see app/Http/Controllers/AuthController.php:357
 * @route '/forget-device'
 */
    const forgetDeviceForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
        action: forgetDevice.url(options),
        method: 'post',
    })

            /**
* @see \App\Http\Controllers\AuthController::forgetDevice
 * @see app/Http/Controllers/AuthController.php:357
 * @route '/forget-device'
 */
        forgetDeviceForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
            action: forgetDevice.url(options),
            method: 'post',
        })
    
    forgetDevice.form = forgetDeviceForm
/**
* @see \App\Http\Controllers\AppController::state
 * @see app/Http/Controllers/AppController.php:102
 * @route '/state'
 */
export const state = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: state.url(options),
    method: 'post',
})

state.definition = {
    methods: ["post"],
    url: '/state',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\AppController::state
 * @see app/Http/Controllers/AppController.php:102
 * @route '/state'
 */
state.url = (options?: RouteQueryOptions) => {
    return state.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\AppController::state
 * @see app/Http/Controllers/AppController.php:102
 * @route '/state'
 */
state.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: state.url(options),
    method: 'post',
})

    /**
* @see \App\Http\Controllers\AppController::state
 * @see app/Http/Controllers/AppController.php:102
 * @route '/state'
 */
    const stateForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
        action: state.url(options),
        method: 'post',
    })

            /**
* @see \App\Http\Controllers\AppController::state
 * @see app/Http/Controllers/AppController.php:102
 * @route '/state'
 */
        stateForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
            action: state.url(options),
            method: 'post',
        })
    
    state.form = stateForm
const app = {
    logout: Object.assign(logout, logout),
forgetDevice: Object.assign(forgetDevice, forgetDevice),
state: Object.assign(state, state),
}

export default app